import { inject } from '@angular/core';
import { NavigationService } from 'app/core/navigation/navigation.service';
import { MessagesService } from 'app/layout/common/messages/messages.service';
import { NotificationsService } from 'app/layout/common/notifications/notifications.service';
import { QuickChatService } from 'app/layout/common/quick-chat/quick-chat.service';
import { ShortcutsService } from 'app/layout/common/shortcuts/shortcuts.service';
import { forkJoin, of } from 'rxjs';
import { ProductionStatusBadgeService } from './shared/components/production-status/production-status-badge.service';
import { Router } from '@angular/router';
import { UserService } from './core/user/user.service';
import { SystemSettingsService } from './modules/admin/system-settings/settings.service';
import {TaxRatesService} from "./modules/mng/tax-rates/tax-rates.service";
import {AbsencesLeaveService} from "./modules/hr/absences-leave-management/absences-leave.service";

export const initialDataResolver = () => {
    const messagesService = inject(MessagesService);
    const navigationService = inject(NavigationService);
    const notificationsService = inject(NotificationsService);
    const quickChatService = inject(QuickChatService);
    const shortcutsService = inject(ShortcutsService);
    const productionStatusBadgeService = inject(ProductionStatusBadgeService);
    const absencesService = inject(AbsencesLeaveService);
    const taxRatesService = inject(TaxRatesService);
    const systemSettingsService = inject(SystemSettingsService);

    // Fork join multiple API endpoint calls to wait all of them to finish
    return forkJoin([
        navigationService.get(),
        messagesService.getAll(),
        notificationsService.getAll(),
        quickChatService.getChats(),
        shortcutsService.getAll(),
        productionStatusBadgeService.getProductionStatuses(),
        absencesService.getAbsencesTypes(),
        // taxRatesService.getTaxRates(),
        systemSettingsService.getCountriesFromDB(),
        // systemSettingsService.getModuleSettings(),
    ]);
};

export const dashboardResolver = () => {
    const router = inject(Router);
    const userService = inject(UserService);

    const dashboard = userService.getFirstAccessibleDashboard();

    if (dashboard) {
        router.navigateByUrl(dashboard);
        return of(null); // Cancel the current navigation
    }

    // Handle the case where no dashboard is accessible
    router.navigate(['/error/500']); // Redirect to access denied page or similar
    return of(null);
};

